import React, { useContext } from "react"
import { View } from "react-native"
import { TouchableRipple } from "react-native-paper"
import { theme } from "../../theme/theme"
import { DimensionsContext } from "../../utils/mobileUtils"
import { IconImageM } from "../icons/IconsM"
import TextM from "../text/TextM"

export function StatisticsItem(props) {
    // ** Component props
    const {
        count,
        totalCount = undefined,
        title,
        color,
        source,
        uri,
        onPress,
        width,
        style,
    } = props

    const dimensions = useContext(DimensionsContext)

    return (
        <TouchableRipple
            style={{
                borderRadius: 15,
                borderColor: theme.colors.lightMore,
                marginRight: 10,
                marginTop: 5,
                flexGrow: 0,
                alignItems: "center",
                justifyContent: "center",
                height: 69,
                width: width ?? dimensions?.width / 2 - 20,
                ...style,
            }}
            onPress={onPress}
            underlayColor={theme.colors.lightMore}
        >
            <View
                style={{
                    borderColor: theme.colors.lightMore,
                    flexDirection: "row",
                    alignItems: "center",
                    paddingLeft: 10,
                    paddingRight: 10,
                }}
            >
                <IconImageM
                    width={30}
                    source={source}
                    uri={uri}
                    style={{
                        marginVertical: 8,
                    }}
                />
                <View
                    style={{
                        paddingVertical: 8,
                        marginLeft: 10,
                        justifyContent: "center",
                    }}
                >
                    <TextM
                        fontWeight="Bold"
                        color={color ?? theme.colors.grey}
                        wrap
                        fontSize={16}
                    >
                        {count}
                        {totalCount !== undefined && (
                            <TextM
                                fontWeight="Medium"
                                color={theme.colors.grey}
                                wrap
                                fontSize={12}
                            >
                                {" "}
                                {totalCount}
                            </TextM>
                        )}
                    </TextM>
                    {title && (
                        <TextM
                            fontWeight="Regular"
                            color={theme.colors.grey}
                            style={{
                                marginTop: 1,
                            }}
                            wrap
                            fontSize={12}
                        >
                            {title}
                        </TextM>
                    )}
                </View>
            </View>
        </TouchableRipple>
    )
}
